import { IButtonProps, INoticeProps, ITextFieldProps } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import AnalyticsService from '../../../services/AnalyticsService';
import { IModalStore } from '../../../stores/ModalStore';
import { IPosPaymentStore } from '../../../stores/PosPaymentStore';
import { ITranslateStore } from '../../../stores/TranslateStore';
import PaymentOptionsModal from './PaymentOptionsModal';

interface IPosPaymentModalProps {
  posPaymentStore?: IPosPaymentStore;
  modalStore?: IModalStore;
  translateStore?: ITranslateStore;
  analyticsService?: AnalyticsService;
}

@inject('posPaymentStore', 'modalStore', 'translateStore', 'analyticsService')
@observer
export default class PosPaymentModal extends React.Component<IPosPaymentModalProps> {
  public render(): JSX.Element {
    const translate = this.props.translateStore.translate;

    return (
      <PaymentOptionsModal
        headingText={translate('invoices.pos-payment-modal.title')}
        buttons={this.buttons()}
        textField={this.textField()}
        modal={{
          isOpen: true,
          onClose: () => this.props.modalStore.closeModal()
        }}
        notice={this.notice()}
      />
    );
  }

  private buttons(): IButtonProps[] {
    const payment = this.props.posPaymentStore.payment;
    const showSpinner = payment.isLoading || payment.isFinished;
    const translate = this.props.translateStore.translate;

    return [
      {
        type: 'employee',
        isLoading: showSpinner,
        text: translate('invoices.pos-payment-modal.make-payment-button'),
        onClick: () => {
          this.props.posPaymentStore.createPayment();
          this.props.analyticsService.posPaymentModalMakePayment();
        }
      }
    ];
  }

  private notice(): INoticeProps {
    const translate = this.props.translateStore.translate;
    const payment = this.props.posPaymentStore.payment;

    if (payment.isFinishedWithError) {
      return {
        type: 'error',
        children: translate('invoices.pos-payment-modal.error-creating-payment')
      };
    }

    return null;
  }

  private textField(): ITextFieldProps {
    const translate = this.props.translateStore.translate;

    return {
      id: 'pos-payment-amount',
      label: translate('invoices.pos-payment-modal.to-pay'),
      value: this.props.posPaymentStore.amount,
      isInvalid: this.props.posPaymentStore.amountFieldHasError,
      onChange: this.props.posPaymentStore.changeAmount,
      icon: '#currency-euro',
      helper: {
        text: this.helperText(),
        type: this.props.posPaymentStore.amountFieldHasError ? 'error' : 'help'
      }
    };
  }

  private helperText(): string {
    const translate = this.props.translateStore.translate;

    if (this.props.posPaymentStore.amountFieldHasError) {
      return translate(this.props.posPaymentStore.amountFieldErrorMsg);
    } else {
      return translate('invoices.pos-payment-modal.you-can-change-sum');
    }
  }
}
